<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Usuarios con acceso mediante credenciales</h6>
        </div>
        <div class="col">
          <button  class="btn bg-gradient-success float-end" @click="$router.push('/users-create')"> Crear agentes</button>
          <button
            class="btn bg-gradient-dark float-end me-2"
            :disabled="!selectedIds.length"
            @click="openBulkIps"
          >
            Asignar IP masivo<span v-if="selectedIds.length"> ({{ selectedIds.length }})</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="table-responsive">
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @change="reloadPaginate(1)">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
          <div class="w-25">
            <input type="text" class="form-control" placeholder="Escribe para buscar por correo o nombre" v-model="pagination.search" @keyup="manualSearch">
          </div>
          <div class="w-25">
            <select class="form-control" v-model="pagination.status" @change="reloadPaginate(1)">
              <option value="active">Usuarios activos</option>
              <option value="inactive">Usuarios inactivos</option>
              <option value="all">Todos los usuarios</option>
            </select>
          </div>
        </div>
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
              <input type="checkbox" :checked="allCurrentSelected" @change="toggleSelectAll">
            </th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo electrónico</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Rol</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">IP permitida</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Porcentaje</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayUsers" :key="key">
            <td>
              <input type="checkbox" :value="item._id" v-model="selectedIds">
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">
                {{item.name}}
                <soft-badge
                  v-if="item.allowed_ip"
                  color="dark"
                  variant="gradient"
                  size="sm"
                  class="ms-1"
                  :title="item.allowed_ip"
                >
                  &#128274;
                </soft-badge>
              </p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.email}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.type}}</p>
            </td>
            <td>
              <soft-badge
                v-if="item.allowed_ip"
                color="dark"
                variant="gradient"
                size="sm"
                class="me-1 mb-1"
              >
                {{ item.allowed_ip }}
              </soft-badge>
              <span v-else class="text-xs text-secondary">Sin IP</span>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.percentage*100}}%</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.status?'ACTIVO':'INACTIVO'}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td>
              <button class="btn btn-danger btn-sm mb-0" @click="remove(item)">{{item.status ? 'Eliminar' : 'Restaurar'}}</button>
              <button class="btn btn-success btn-sm mb-0" @click="view(item)">Ver</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">Total de filas: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>

    <teleport to="body">
    <div v-if="showBulkModal" class="ip-modal-backdrop" @click.self="closeBulkIps">
      <div class="card ip-modal-card">
        <div class="card-header pb-0">
          <h6>Asignar IP a {{ selectedIds.length }} agente(s)</h6>
          <p class="text-xs text-secondary mb-0">
            La misma IP se aplicará a todos los agentes seleccionados.
            Vacío = los agentes NO podrán iniciar sesión (salvo administrador).
          </p>
        </div>
        <div class="card-body px-4">
          <input type="text" class="form-control" placeholder="Ej. 192.168.0.1" v-model="bulkIp" />
          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-outline-secondary mb-0 me-2" @click="closeBulkIps">Cancelar</button>
            <button class="btn bg-gradient-success mb-0" @click="confirmBulkIps">Asignar</button>
          </div>
        </div>
      </div>
    </div>
    </teleport>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";
import SoftBadge from "@/components/SoftBadge.vue";


export default {
  name: "index",
  components: {SoftBadge},
  data: () => ({
    arrayUsers: [],
    selectedIds: [],
    showBulkModal: false,
    bulkIp: '',
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      status: 'active',
      totalRows: 0
    }
  }),
  computed: {
    allCurrentSelected(){
      return this.arrayUsers.length > 0 &&
        this.arrayUsers.every(u => this.selectedIds.includes(u._id))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.selectedIds = []
      this.getData()
    },
    toggleSelectAll(e){
      if (e.target.checked) {
        const ids = this.arrayUsers.map(u => u._id)
        this.selectedIds = [...new Set([...this.selectedIds, ...ids])]
      } else {
        const currentIds = this.arrayUsers.map(u => u._id)
        this.selectedIds = this.selectedIds.filter(id => !currentIds.includes(id))
      }
    },
    openBulkIps(){
      if (!this.selectedIds.length) return
      this.bulkIp = ''
      this.showBulkModal = true
    },
    closeBulkIps(){
      this.showBulkModal = false
    },
    async confirmBulkIps(){
      try {
        await post('users/assign-ip-bulk', {ids: this.selectedIds, allowed_ip: this.bulkIp.trim()})
        const count = this.selectedIds.length
        this.showBulkModal = false
        this.selectedIds = []
        await this.getData()
        this.$swal({
          html: `IP asignada a ${count} agente(s)`,
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      } catch (e) {
        this.$swal({
          html: 'Ocurrió un error al asignar las IPs',
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },

    async getData(){
      this.arrayUsers = []
      const {data} = await get(`users/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${encodeURIComponent(this.pagination.search)}&status=${this.pagination.status}`,null, true)
      this.arrayUsers = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    async remove(item){
      this.$swal({
        html: '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("users/remove",{_id: item._id}, true)
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.getData()
        }
      })
    },
    view(item){
      this.$router.push({name: 'agents-view', query: {id: item._id}})
    }
  }
}
</script>

<style scoped lang="scss">
.ip-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  // El sidenav del template (soft-ui _navbar-vertical) tiene z-index 9999;
  // el backdrop DEBE quedar por encima o el sidebar flota sobre el overlay.
  z-index: 10000;
}
.ip-modal-card {
  width: 100%;
  max-width: 520px;
  margin: 1rem;
}
</style>
